import { createSelector } from '@reduxjs/toolkit';
import { getUserId, getUserRole } from 'store/session/selectors';

export const viewAppointmentSelector = createSelector(
    getUserId,
    getUserRole,

    (userId, role) => ({
        userId,
        role: role?.name || '',
    }),
);
